module.exports = __webpack_public_path__ + "img/蒺藜.cc51f855.jpg";